/**
* Can be used to verify switch cases / if else branches are exhaustive, i.e. every case is covered.
*/
export const assertUnreachable = (x: never): never => {
    throw new Error('Didn\'t expect to get here with value: ' + x);
};
